import { get, makeSlug } from '../../utils';

export const getTrimsByModelLineCode = (state, modelLineCode) => {
  const trims = get(state, `trims.trims.${modelLineCode}`) || [];
  return trims.map(trim => ({
    ...trim,
    slug: makeSlug(trim.trimName)
  }));
}

export const getActiveModelLineTrims = (state) => {
  const activeMLC = get(state, 'navigation.modelLineCode');
  return getTrimsByModelLineCode(state, activeMLC);
};

export const getActiveTrimNCode = state => get(state, 'navigation.nCode')

export const getTrimByNcode = (state, nCode) => {
  const trims = getActiveModelLineTrims(state);
  return trims.find(trim => trim.nCode === nCode)
}

export const getTrimBySlug = (state, slug) => {
  const trims = getActiveModelLineTrims(state);
  return trims.find(trim => trim.slug === makeSlug(slug))
}

export const getActiveTrim = (state) => {
  const activeNcode = getActiveTrimNCode(state);
  return getTrimByNcode(state, activeNcode)
}

export const getActiveTrimName = (state) => {
  const activeTrim = getActiveTrim(state);
  if (!activeTrim) {
    return undefined;
  }
  return activeTrim.trimName;
}

export const getActiveTrimYear = (state) => {
  const activeTrim = getActiveTrim(state);
  if (!activeTrim) {
    return undefined;
  }
  return activeTrim.year;
}

export const getNcodeBySlugAndModelLineCode = (state, trimSlug, modelLineCode) => {
  if (!trimSlug || !modelLineCode) {
    return undefined;
  }
  const trims = getTrimsByModelLineCode(state, modelLineCode);
  const trimByName = trims.find(t => t.slug === makeSlug(trimSlug));
  const trimByNcode = trims.find(t => makeSlug(t.nCode) === makeSlug(trimSlug));
  const activeTrim = trimByName || trimByNcode;
  const nCode = (activeTrim) ? activeTrim.nCode : undefined;
  return nCode;
}

export const hasUserSelectedTrim = state => state.trims.trimSelected;



/** WEBPACK FOOTER **
 ** ./src/redux/selectors/trim.js
 **/